import { render, staticRenderFns } from "./CardPairedMember.vue?vue&type=template&id=54cf6738&scoped=true"
import script from "./CardPairedMember.vue?vue&type=script&lang=js"
export * from "./CardPairedMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf6738",
  null
  
)

export default component.exports